export const guardedRoute = [
  "Messages",
  "MyTasks",
  "Settings",
  "Profile",
  "Earnings",
  "MyProjects",
  "UserDashboard",
];
